import { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Icon } from '@openedx/paragon';
import {
  RiSearch2Line,
  RiFilterOffLine,
  RiArrowDownSLine,
  RiGridLine,
  RiListUnordered,
} from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../messages';

const LibraryHeader = ({
  searchValue,
  onSearchChange,
  sortOrder,
  onSortChange,
  viewMode,
  onViewModeChange,
}) => {
  const intl = useIntl();
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);

  return (
    <section className="library-header">
      <div className="library-header__top-row">
        <h2 className="library-header__title">{intl.formatMessage(messages.headerTitle)}</h2>

        <div className="library-header__actions">
          <div className="library-header__sort">
            <span className="library-header__sort-label">{intl.formatMessage(messages.sortByLabel)}</span>
            <div className="library-header__sort-dropdown">
              <button
                type="button"
                className="library-header__sort-btn"
                onClick={() => setSortDropdownOpen((prev) => !prev)}
              >
                <span>
                  {sortOrder === 'latest'
                    ? intl.formatMessage(messages.sortLatest)
                    : intl.formatMessage(messages.sortOldest)}
                </span>
                <Icon src={RiArrowDownSLine} size="inline" />
              </button>
              {sortDropdownOpen && (
                <div className="library-header__sort-menu">
                  <button
                    type="button"
                    className={`library-header__sort-option ${sortOrder === 'latest' ? 'library-header__sort-option--active' : ''}`}
                    onClick={() => { onSortChange('latest'); setSortDropdownOpen(false); }}
                  >
                    {intl.formatMessage(messages.sortLatest)}
                  </button>
                  <button
                    type="button"
                    className={`library-header__sort-option ${sortOrder === 'oldest' ? 'library-header__sort-option--active' : ''}`}
                    onClick={() => { onSortChange('oldest'); setSortDropdownOpen(false); }}
                  >
                    {intl.formatMessage(messages.sortOldest)}
                  </button>
                </div>
              )}
            </div>
          </div>

          <button
            type="button"
            className="library-header__view-toggle"
            onClick={() => onViewModeChange(viewMode === 'grid' ? 'table' : 'grid')}
            aria-label={viewMode === 'grid'
              ? intl.formatMessage(messages.switchToTableView)
              : intl.formatMessage(messages.switchToGridView)}
          >
            {viewMode === 'grid' ? (
              <RiListUnordered size={16} color="rgba(100,100,100,1)" />
            ) : (
              <RiGridLine size={16} color="rgba(100,100,100,1)" />
            )}
          </button>
        </div>
      </div>

      <div className="library-header__search-row">
        <Form.Control
          size="lg"
          placeholder={intl.formatMessage(messages.searchPlaceholder)}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          leadingElement={<RiSearch2Line size={16} color="#838383" />}
        />
        <Button
          variant="outline-secondary"
          size="lg"
          iconBefore={RiFilterOffLine}
        >
          {intl.formatMessage(messages.filterButton)}
        </Button>
      </div>
    </section>
  );
};

LibraryHeader.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  sortOrder: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  viewMode: PropTypes.oneOf(['table', 'grid']).isRequired,
  onViewModeChange: PropTypes.func.isRequired,
};

export default LibraryHeader;
